import spiderman from '@/spiderman/index';

async function login(member, loginForm) {
  return (
    await spiderman.axios.post(spiderman.api.member.login,
      loginForm,
      {
        headers: {
          jwt: member.jwt,
        },
      })
  ).data;
}

async function logout(member) {
  return (
    await spiderman.axios.put(spiderman.api.member.logout,
      {
        twid: member.info.twid,
        birthdate: member.info.birthdate,
      },
      {
        headers: {
          jwt: member.jwt,
        },
      })
  ).data;
}

async function accountRecovery(member, mobileForm) {
  return (
    await spiderman.axios.put(spiderman.api.member.accountRecovery,
      mobileForm,
      {
        headers: {
          jwt: member.jwt,
        },
      })
  ).data;
}

async function changePassword(member, password) {
  return (
    await spiderman.axios.put(spiderman.api.member.password, {
      twid: member.info.twid,
      birthdate: member.info.birthdate,
      password,
    },
    {
      headers: {
        jwt: member.jwt,
      },
    })
  ).data;
}

async function changeClinic(member) {
  return (
    await spiderman.axios.put(spiderman.api.member.clinic, {
      twid: member.info.twid,
      birthdate: member.info.birthdate,
      clinic: member.info.clinic,
    },
    {
      headers: {
        jwt: member.jwt,
      },
    })
  ).data;
}

export default {
  login,
  logout,
  accountRecovery,
  changePassword,
  changeClinic,
};
